<div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzXl="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Basic
        </h4>
      </div>
      <div class="p-[25px]">
          <nz-demo-input-basic></nz-demo-input-basic>
      </div>
    </div>
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Textarea
        </h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-input-textarea></nz-demo-input-textarea>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzXl="12" class="mb-[25px]">
    <div class="bg-white dark:bg-white/10 mb-[25px] p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative">
      <div class="px-[25px] py-[15px] text-dark dark:text-white/[.87] font-medium text-[17px] flex flex-wrap items-center justify-between max-sm:flex-col max-sm:h-auto max-sm:mb-[15px] border-b border-[#F1F2F6] dark:border-white/10">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Three sizes of Input
        </h4>
      </div>
      <div class="p-[25px]">
        <nz-demo-input-size></nz-demo-input-size>
      </div>
    </div>
  </div>
</div>
